import { FreeTrialRequest, FreeTrialResponse } from "../model/free-trial-types";
import { publicClient } from "@/shared/api/public-client";

/**
 * 무료체험 신청 API
 */
class FreeTrialAPI {
  /**
   * 무료체험 신청
   */
  async submitFreeTrial(data: FreeTrialRequest): Promise<FreeTrialResponse> {
    try {
      const response = await publicClient.post<FreeTrialResponse>(
        "/free-trial/apply",
        data
      );
      return response.data;
    } catch (err) {
      throw this.handleError(err);
    }
  }

  private handleError(err: any): Error {
    if (err.response?.data?.message) {
      return new Error(err.response.data.message);
    }
    return err instanceof Error ? err : new Error("무료체험 신청 중 오류가 발생했습니다.");
  }
}

export const freeTrialAPI = new FreeTrialAPI();
